import _ from "lodash";
/**-- external -- */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import classNames from "classnames";

/** -- internal -- */
import { useI18n } from "Hooks";
import { navigateToFeature } from "Courses/components/TeacherCourses/module/Module";

/** -- relative -- */
import {
  getAvailableProjectGroupTypes,
  getIsGlobalSearchJumpToRevampEnabled,
  JUMP_TO_COLUMNS,
  trackJumpToCardClick,
} from "GlobalHeader/modules/Utils";
import classes from "./ProjectsFeed.scss";
import { ProjectsCard } from "./components";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getCurrentCurriculumContextForJumpTo } from "modules/CommonSelectors";
import { HeadingText } from "../../commonComponents";

const ProjectsFeed = props => {
  const {
    testId,
    projectGroups,
    onNavigationDone,
    navigateToFeature,
    updateAvailableProjects,
    currentCurriculumProgramId,
    userId,
    organizationId,
    columnIndex,
    userType,
    identityId,
    role,
    currentCurriculumProgramType,
  } = props;

  const { t } = useI18n(["common"]);
  const localTestId = `${testId}-projectsFeed`;

  const availableProjectGroupTypes = getAvailableProjectGroupTypes({
    projectGroups,
    currentCurriculumProgramId,
    userId,
    organizationId,
    userType,
    identityId,
    role,
    currentCurriculumProgramType,
  });

  const header = t("common:projects");

  const headerClasses = classNames(classes.header, "text-label-4");

  /**
   * Side effect to update available project shortcuts
   */
  useEffect(() => {
    updateAvailableProjects(availableProjectGroupTypes);
  }, [availableProjectGroupTypes]);

  const isGlobalSearchJumpToRevampEnabled = getIsGlobalSearchJumpToRevampEnabled();

  const containerClasses = isGlobalSearchJumpToRevampEnabled
    ? classes.containerV2
    : classes.container;

  const projectGroupFeedClasses = isGlobalSearchJumpToRevampEnabled
    ? classes.projectGroupFeedV2
    : classes.projectGroupFeed;

  const onProjectCardClick = ({ projectGroupType }) => e => {
    const isMouseClick = !!e.isTrusted;

    trackJumpToCardClick({
      e,
      featureType: JUMP_TO_COLUMNS.PROJECTS_FEED,
      featureId: projectGroupType,
      isMouseClick,
    });

    navigateToFeature({
      feature: projectGroupType,
      allowCrossCurriculumNavigation: true,
      t,
    });
    onNavigationDone();
  };

  return (
    <div className={containerClasses}>
      {isGlobalSearchJumpToRevampEnabled ? (
        <HeadingText text={header} />
      ) : (
        <div className={headerClasses}>{header}</div>
      )}
      <div className={projectGroupFeedClasses}>
        {_.map(availableProjectGroupTypes, (projectGroupType, index) => (
          <ProjectsCard
            key={projectGroupType}
            projectGroupType={projectGroupType}
            testId={localTestId}
            onCardClick={onProjectCardClick({ projectGroupType })}
            columnIndex={columnIndex}
            shortcutKey={index + 1}
            shiftKey={true}
          />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    id: currentCurriculumProgramId,
    type: currentCurriculumProgramType,
  } = getCurrentCurriculumContextForJumpTo(state);

  const userInfo = getUserInfo();
  const {
    id: userId,
    org_id: organizationId,
    user_type: userType,
    identityId,
    role,
  } = userInfo;

  return {
    currentCurriculumProgramId,
    userId,
    organizationId,
    userType,
    identityId,
    role,
    currentCurriculumProgramType,
  };
};

const mapActionCreators = {
  navigateToFeature,
};

export default compose(connect(mapStateToProps, mapActionCreators))(
  ProjectsFeed
);
